<template>
    <div v-if="initialized">

        <el-form-item label="Title" prop="titles.title">
            <el-input v-model="formValues.title" @input="updateFormValues" maxlength="120" show-word-limit/>
        </el-form-item>

        <el-form-item v-if="isTrUser"
                      label="Job Nickname (to distinguish between jobs in the adminCP)"
                      prop="titles.adminDescription">
            <el-input v-model="formValues.adminDescription" @input="updateFormValues" maxlength="60" show-word-limit/>
        </el-form-item>

        <el-form-item v-if="isTrUser" label="Alternative titles (A/B testing)">
            <el-input
                    v-for="n in abTitlesCount"
                    v-model="formValues.abTitles[(n - 1)]"
                    @input="updateFormValues"
                    :key="`abTitle${n}`"
                    style="margin-bottom:6px"/>
        </el-form-item>

        <JobFormTitlesDescription v-if="jobId !== 0" :description="description"/>

    </div>
</template>

<script>
import JobFormTitlesDescription from './titles/job-form-titles-description.vue';

export default {
        components: { JobFormTitlesDescription },
        props: {
            jobId: { type: Number, required: true },
            isTrUser: { type: Boolean, required: true },
            value: { type: Object, required: true },
        },
        data() {
            return {
                abTitlesCount: 3,
                initialized: false,
                description: '',
                formValues: this.value,
            };
        },
        // watch: {
        //     jobId: {
        //         deep: false,
        //         handler() {
        //             this.loadData();
        //         },
        //     }
        // },
        computed: {},
        mounted() {
            if (this.jobId === 0) {
                if (this.isTrUser) {
                    this.$set(this.formValues, 'abTitles', []);
                }
                this.initialized = true;
                this.$emit('initialized', 'titles');
            } else {
                this.loadData();
            }
        },
        methods: {
            updateFormValues() { this.$emit('input', this.formValues); },
            loadData() {
                axios.get(url(`/admin/jobs/load-form-titles-data?jobId=${this.jobId}`))
                    .then(response => {
                        if (response.status !== 200 || typeof response.data.title === 'undefined') {
                            throw Error('Internal server error, please contact administrator.');
                        }

                        this.description = response.data.description;
                        this.$set(this.formValues, 'title', response.data.title);
                        if (this.isTrUser) {
                            this.$set(this.formValues, 'adminDescription', response.data.adminDescription);

                            const abTitles = typeof response.data.abTitles === 'undefined'
                                ? []
                                : response.data.abTitles;
                            this.$set(this.formValues, 'abTitles', []);
                            for(let n = 0; n < this.abTitlesCount; n++) {
                                this.$set(this.formValues.abTitles, n,
                                    (typeof abTitles[n] === 'undefined' ? '' : abTitles[n]));
                            }
                        }

                        this.initialized = true;
                        this.$emit('initialized', 'titles');
                        this.updateFormValues();
                    })
                    .catch(err => this.$emit('error', err.message));
            }
        },
    };
</script>
